<template>

<layout>
  <template v-slot:body>
    <div class="mobile">
      <div
        class="phone"
        :class="{ phone_mobile: isMobile }">
        <div class="phone__wrap">
          <div class="phone__template">
            <div class="template" :class="{ template_mobile: isMobile }">
              <div ref="tempBody" class="template__body">

                <component
                  v-if="isMobile"
                  :is="platform"
                  :id="m_id"
                  :key="m_id"
                  @shift="CHANGE_SHIFT"
                  @ready="ready">
                </component>

                <videoTag v-else :videoPath="videoPath"></videoTag>

              </div>
            </div>
          </div>
          <img
            v-if="!isMobile"
            src="@/assets/phone.png"
            alt="buzz phone"
            class="phone__img">
        </div>
      </div>

      <div class="qr" :class="{ qr_hide: isMobile }">
        <img
          src="@/assets/qrcode.gif"
          width="132"
          height="132" border="0" title="QR код">
        <div class="qr__text">Смотреть на телефоне</div>
      </div>

    </div>
  </template>
</layout>

</template>

<script>
// import iFrame from '@/components/iFrame.vue';
import layout from '@/components/layout.vue';
import videoTag from '@/components/videoTag.vue';
import hello from '@/components/pages/hello.vue';
import cosmo from '@/components/pages/cosmo.vue';
import elle from '@/components/pages/elle.vue';
import drive2 from '@/components/pages/drive2.vue';
import autovesti from '@/components/pages/autovesti.vue';
import autovesti2 from '@/components/pages/autovesti2.vue';
import championat from '@/components/pages/championat.vue';
import soccer from '@/components/pages/soccer.vue';
import village from '@/components/pages/village.vue';
import maxim from '@/components/pages/maxim.vue';
import vesti from '@/components/pages/vesti.vue';
import m24 from '@/components/pages/m24.vue';
import kolesa from '@/components/pages/kolesa.vue';
import { isMobile } from 'mobile-device-detect';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Mobile',
  props: {
    m_id: {
      type: String,
    },
  },
  data() {
    return {
      isMobile,
    };
  },
  components: {
    layout,
    elle,
    hello,
    cosmo,
    drive2,
    autovesti,
    autovesti2,
    championat,
    soccer,
    village,
    maxim,
    vesti,
    m24,
    kolesa,
    videoTag,
    // iFrame,
  },
  computed: {
    ...mapGetters({
      creativesMobile: ['getMobileCreatives'],
    }),
    videoPath() {
      let videoPath = {};
      if (this.m_id) {
        videoPath = {
          mp4: `/video/${this.m_id}/video.mp4`,
        };
      } else {
        videoPath = {
          mp4: '/video/mobileNativeUnit/video.mp4',
        };
      }
      return videoPath;
    },
    platform() {
      let platform = '';
      if (this.m_id) {
        for (let i = 0; i < this.creativesMobile.length; i += 1) {
          if (this.creativesMobile[i].id === this.m_id) {
            platform = this.creativesMobile[i].platform;
          }
        }
      } else if (this.creativesMobile[0]) {
        platform = this.creativesMobile[0].platform;
      } else {
        platform = 'hello';
      }
      return platform;
    },
  },
  methods: {
    ...mapMutations([
      'CHANGE_SHIFT',
    ]),
    ready() {},
    isIe() {
      const ua = window.navigator.userAgent;
      const isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
      return isIe;
    },
  },
};
</script>

<style scoped lang='stylus'>

m-1200()
  @media all and (max-width: 1200px)
    {block}

m-980()
  @media all and (max-width: 980px)
    {block}

iframe
  position absolute
  left 0
  top 0
  width 100%
  height 100%

.qr
  width 160px
  position absolute
  top 40%
  right 4%
  text-align center
  font-size 14px
  line-height 16px
  font-family 'Roboto', sans-serif
  font-weight 500
  color #000
  +m-1200()
    position inherit
    top 0
    right 0
    margin 40px auto
  &_hide
    display none

.template
  position relative
  // height 100%
  width 100%
  background white
  font-size 20px
  line-height normal
  font-family Helvetica, sans-serif
  &__body
    position relative
    width 100%
  &__title
    font-size 19px
    line-height 23px
  &__pretitle
    font-size 16px
    line-height 20px
  &__desc
    font-size 14px
    line-height 18px
    text-align left
  &__image
    display block
    width 100%
    height auto
    margin-bottom 20px
  &__header
    position absolute
    left 0
    top 0
    width 100%
    z-index 10
    background white

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px

.header
  width 100%
  padding 10px 50px
  position relative
  text-align center
  box-sizing border-box
  overflow hidden
  &__menu
    width 30px
    height 30px
    position absolute
    left 10px
    top 10px
    -webkit-tap-highlight-color transparent
    outline none
    & svg
      width 100%
      height 100%
      fill #000
    &_mobile
      width 20px
      height 20px
      left 20px
      top 15px
  &__logo
    width 100%
    text-align center
  &__logo-img
    display block
    width auto
    height 30px
    margin 0 auto
  &.championat
    background #000
    padding 10px 60px
    & svg
      fill #fff
    & ^[0]__logo-img
      margin 0
  &.cosmo
    border-bottom 1px solid rgba(170,170,170,0.5)
    background-color #303030
    & svg
      fill #fff
  &.drive2
    padding 0 0 0 50px
    background #000
    & svg
      fill #fff
    & ^[0]__logo-img
      height 50px
      margin 0
      float right
  &.autovesti
  &.autovesti2
    & ^[0]__logo-img
      margin 10px auto
      height 12px
  &.village
    background #036
    & svg
      fill #fff
  &.soccer
    padding 5px 50px 10px
    & ^[0]__logo-img
      height 38px
    & svg
      fill #ff9f25
  &.maxim
    & svg
      fill #ba1909
  &.vesti
    background #0095da
    padding 5px 0 0
    & svg
      fill #fff
    & ^[0]__logo-img
      height 50px
    & ^[0]__logo
      padding-left 35px
      box-sizing border-box
  &.m24
    & ^[0]__logo-img
      height 20px
      margin 5px auto

.phone
  width 100%
  text-align center
  &_mobile
    margin 0
    height 100%
  &__wrap
    position relative
    display inline-block
    margin 2.5vh auto 0
    width auto
    ^[0]_mobile &
      width 100%
      margin 0 auto
    //   width 100vw
    //   height 100vh
  &__img
    position relative
    width auto
    height 95vh
    z-index 9999
    pointer-events none
  &__template
    position absolute
    left 0
    top 0
    width 100%
    height 100%
    padding 17% 7% 7% 7%
    box-sizing border-box
    ^[0]_mobile &
      padding 0
      position relative
      height auto

</style>
